import { I18nProvider } from '@lingui/react'
import { hydrate } from 'react-dom'
import { Provider } from 'react-redux'

import store from 'shared/store'
import { ShopAndRuntimeConfigContext } from 'views/components/templates/helpers'

export default ({ container, i18n }) =>
  async children => {
    const { publicConfig, pageProperties } = store.getPublicRuntimeConfig()

    if (container === null) {
      throw new Error('No container passed for hydrateWithHOCs')
    }

    hydrate(
      <ShopAndRuntimeConfigContext.Provider
        value={{ publicConfig, pageProperties }}
      >
        <Provider store={store}>
          <I18nProvider i18n={i18n}>{children}</I18nProvider>
        </Provider>
      </ShopAndRuntimeConfigContext.Provider>,
      container
    )
  }
